import {
	type DeepKeys,
	type DeepValue,
	type FieldAsyncValidateOrFn,
	type FieldMeta as FieldMetaBase,
	type FieldValidateOrFn,
	type FormAsyncValidateOrFn,
	type FormOptions,
	type FormValidateOrFn,
	type ReactFormExtendedApi,
	useForm as useFormBase,
} from "@tanstack/react-form";

export const useForm = <TFormData>(
	opts?: FormOptions<
		TFormData,
		FormValidateOrFn<TFormData>,
		FormValidateOrFn<TFormData>,
		FormAsyncValidateOrFn<TFormData>,
		FormValidateOrFn<TFormData>,
		FormAsyncValidateOrFn<TFormData>,
		FormValidateOrFn<TFormData>,
		FormAsyncValidateOrFn<TFormData>,
		FormValidateOrFn<TFormData>,
		FormAsyncValidateOrFn<TFormData>,
		FormAsyncValidateOrFn<TFormData>,
		FormAsyncValidateOrFn<TFormData>
	>,
): ReactFormExtendedApi<
	TFormData,
	FormValidateOrFn<TFormData>,
	FormValidateOrFn<TFormData>,
	FormAsyncValidateOrFn<TFormData>,
	FormValidateOrFn<TFormData>,
	FormAsyncValidateOrFn<TFormData>,
	FormValidateOrFn<TFormData>,
	FormAsyncValidateOrFn<TFormData>,
	FormValidateOrFn<TFormData>,
	FormAsyncValidateOrFn<TFormData>,
	FormAsyncValidateOrFn<TFormData>,
	FormAsyncValidateOrFn<TFormData>
> =>
	useFormBase<
		TFormData,
		FormValidateOrFn<TFormData>,
		FormValidateOrFn<TFormData>,
		FormAsyncValidateOrFn<TFormData>,
		FormValidateOrFn<TFormData>,
		FormAsyncValidateOrFn<TFormData>,
		FormValidateOrFn<TFormData>,
		FormAsyncValidateOrFn<TFormData>,
		FormValidateOrFn<TFormData>,
		FormAsyncValidateOrFn<TFormData>,
		FormAsyncValidateOrFn<TFormData>,
		FormAsyncValidateOrFn<TFormData>
	>(opts);

export type FieldMeta<TFormData> = FieldMetaBase<
	TFormData,
	DeepKeys<TFormData>,
	DeepValue<TFormData, DeepKeys<TFormData>>,
	FieldValidateOrFn<
		TFormData,
		DeepKeys<TFormData>,
		DeepValue<TFormData, DeepKeys<TFormData>>
	>,
	FieldValidateOrFn<
		TFormData,
		DeepKeys<TFormData>,
		DeepValue<TFormData, DeepKeys<TFormData>>
	>,
	| FieldAsyncValidateOrFn<
			TFormData,
			DeepKeys<TFormData>,
			DeepValue<TFormData, DeepKeys<TFormData>>
	  >
	| undefined,
	| FieldValidateOrFn<
			TFormData,
			DeepKeys<TFormData>,
			DeepValue<TFormData, DeepKeys<TFormData>>
	  >
	| undefined,
	| FieldValidateOrFn<
			TFormData,
			DeepKeys<TFormData>,
			DeepValue<TFormData, DeepKeys<TFormData>>
	  >
	| undefined,
	| FieldValidateOrFn<
			TFormData,
			DeepKeys<TFormData>,
			DeepValue<TFormData, DeepKeys<TFormData>>
	  >
	| undefined,
	| FieldValidateOrFn<
			TFormData,
			DeepKeys<TFormData>,
			DeepValue<TFormData, DeepKeys<TFormData>>
	  >
	| undefined,
	| FieldValidateOrFn<
			TFormData,
			DeepKeys<TFormData>,
			DeepValue<TFormData, DeepKeys<TFormData>>
	  >
	| undefined,
	| FieldValidateOrFn<
			TFormData,
			DeepKeys<TFormData>,
			DeepValue<TFormData, DeepKeys<TFormData>>
	  >
	| undefined,
	FormValidateOrFn<TFormData>,
	FormValidateOrFn<TFormData> | undefined,
	FormAsyncValidateOrFn<TFormData>,
	FormValidateOrFn<TFormData> | undefined,
	FormValidateOrFn<TFormData>,
	FormValidateOrFn<TFormData> | undefined,
	FormValidateOrFn<TFormData>,
	FormValidateOrFn<TFormData> | undefined,
	FormAsyncValidateOrFn<TFormData>
>;
